// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/usage.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetActiveUsersCountRequest, GetActiveUsersCountResponse, GetActiveUsersTimeSeriesRequest, GetActiveUsersTimeSeriesResponse, GetTopActiveUsersRequest, GetTopActiveUsersResponse } from "./usage_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * UsageService provides usage information about environments, users, and projects.
 *
 * @generated from service gitpod.v1.UsageService
 */
export const UsageService = {
  typeName: "gitpod.v1.UsageService",
  methods: {
    /**
     * Gets the count of active users.
     *
     * Returns the count of unique users who were active within the specified date range.
     *
     * @generated from rpc gitpod.v1.UsageService.GetActiveUsersCount
     */
    getActiveUsersCount: {
      name: "GetActiveUsersCount",
      I: GetActiveUsersCountRequest,
      O: GetActiveUsersCountResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Gets the top active users based on total runtime.
     *
     * Returns a list of users sorted by their total environment runtime within the specified date range.
     * Each result includes the user ID, name (if available), and their total environment runtime in seconds.
     *
     * @generated from rpc gitpod.v1.UsageService.GetTopActiveUsers
     */
    getTopActiveUsers: {
      name: "GetTopActiveUsers",
      I: GetTopActiveUsersRequest,
      O: GetTopActiveUsersResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Gets active users time series in the specified date range, aggregated by the specified resolution.
     *
     * Returns a time series of active user counts within the specified date range, aggregated by the specified resolution.
     * Each data point includes the timestamp and the count of unique users who were active at that time.
     *
     * @generated from rpc gitpod.v1.UsageService.GetActiveUsersTimeSeries
     */
    getActiveUsersTimeSeries: {
      name: "GetActiveUsersTimeSeries",
      I: GetActiveUsersTimeSeriesRequest,
      O: GetActiveUsersTimeSeriesResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
  }
} as const;

